// extracted by mini-css-extract-plugin
export default {"listAddCard":"AddCard_listAddCard__r115k"};